import { t } from "i18next";

import { FieldBuilder, MultiPageFormBuilder } from "../../formBuilder/index.js";
import {
  commandUnitSchema,
  dispatchNumberSchema,
  forenameSchema,
  nonFutureDateOrDateTimeSchema,
  OrganisationRoleSchema,
  surnameSchema,
} from "../../types/index.js";
import { tk } from "../../types/Translation.js";

export const formSpecification = new MultiPageFormBuilder()
  .withFieldAlwaysVisible({
    fieldName: "dispatchNumber", // create-1.1
    type: "textbox",
    ...new FieldBuilder().withSchema(dispatchNumberSchema).build(),
    label: tk("createIncident.dispatchNumber.label"),
    placeholder: tk("createIncident.dispatchNumber.placeholder"),
    requiredLabel: tk("fieldSchema.dispatchNumber.required"),
  })
  .withFieldAlwaysVisible({
    fieldName: "dispatchNumberCreated", // create-2.1
    type: "date-time",
    dateLabel: tk("createIncident.dispatchNumberCreatedDate"),
    timeLabel: tk("createIncident.dispatchNumberCreatedTime"),
    label: tk("createIncident.dispatchNumberCreated"),
    requiredLabel: tk("createIncident.dispatchNumberCreatedRequired"),
    disableFuture: true,
    ...new FieldBuilder().withSchema(nonFutureDateOrDateTimeSchema).build(),
  })
  .withFieldAlwaysVisible({
    fieldName: "commandUnit", // create-3.1
    type: "organisation",
    filterByRoles: [OrganisationRoleSchema.enum.PoliceCommandUnit],
    ...new FieldBuilder()
      .withSchema(commandUnitSchema)
      .captureValueLabel()
      .build(),
    label: tk("createIncident.commandUnit"),
    requiredLabel: tk("createIncident.commandUnitRequired"),
  })
  .withFieldAlwaysVisible({
    fieldName: "personForename", // create-4.1
    type: "textbox",
    ...new FieldBuilder().withUnknowableSchema(forenameSchema).build(),
    label: tk("createIncident.personForename"),
    requiredLabel: tk("createIncident.personForenameRequired"),
  })
  .withFieldAlwaysVisible({
    fieldName: "personSurname", // create-4.2
    type: "textbox",
    ...new FieldBuilder().withUnknowableSchema(surnameSchema).build(),
    label: tk("createIncident.personSurname"),
    requiredLabel: tk("createIncident.personSurnameRequired"),
  })
  .withPage([
    "dispatchNumber", // create-1.1
    "dispatchNumberCreated", // create-2.1
  ])
  .withPage([
    "commandUnit", // create-3.1
  ])
  .withPage([
    "personForename", // create-4.1
    "personSurname", // create-4.2
  ])
  .build({ t });

export type CreateIncidentWorkItemFormData = ReturnType<
  typeof formSpecification
>["formType"];
